import { render, staticRenderFns } from "./BorderInput.vue?vue&type=template&id=91feb6da&scoped=true&"
import script from "./BorderInput.vue?vue&type=script&lang=js&"
export * from "./BorderInput.vue?vue&type=script&lang=js&"
import style0 from "./BorderInput.vue?vue&type=style&index=0&id=91feb6da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91feb6da",
  null
  
)

export default component.exports